import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import TbExpense from '@/types/table/tbExpense';
import { TbExpenseDetailData } from '@/api/generated/tbExpenseDetailController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface TbExpenseData extends TbExpense {
  tbExpenseDetailList?: TbExpenseDetailData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class TbExpenseController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<TbExpenseData>>(API_CONTEXT + '/upms/tbExpense/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<TbExpenseData>(API_CONTEXT + '/upms/tbExpense/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/tbExpense/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/tbExpense/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/tbExpense/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpense/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpense/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpense/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpense/deleteBatch', params, httpOptions);
  }
  static startOnlyExpenseApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpense/startOnly/ExpenseApply', params, httpOptions);
  }
  static startWithBusinessKeyExpenseApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpense/startWithBusinessKey/ExpenseApply', params, httpOptions);
  }
  static startAndTakeUserTaskExpenseApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpense/startAndTakeUserTask/ExpenseApply', params, httpOptions);
  }
  static startAndSaveDraftExpenseApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpense/startAndSaveDraft/ExpenseApply', params, httpOptions);
  }
  static submitUserTaskExpenseApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpense/submitUserTask/ExpenseApply', params, httpOptions);
  }
  static viewTaskBusinessDataExpenseApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/tbExpense/viewTaskBusinessData/ExpenseApply', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataExpenseApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/upms/tbExpense/viewHistoricTaskBusinessData/ExpenseApply', params, httpOptions);
  }
  static listWorkOrderExpenseApply(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpense/listWorkOrder/ExpenseApply', params, httpOptions);
  }
}
